import { useLocalStorage } from '@mantine/hooks';

import { FeatureFlag } from '@ndvr/auth-api';

import { useAssignedFlags } from 'views/auth/auth-queries';

export type PageVersion = 'new' | 'legacy';
export const PAGE_VERSION_STORAGE_KEY = 'cc-page-version';

/** One browser-wide preference shared by every new/legacy page switch, honoured only while the flag is on. */
export const usePageVersion = () => {
    const { data: flags, isPending } = useAssignedFlags();
    const enabled = !!flags?.includes(FeatureFlag.CC_NEW_ACCOUNT_PAGES);
    const [storedVersion, setView] = useLocalStorage<PageVersion | null>({
        key: PAGE_VERSION_STORAGE_KEY,
        defaultValue: null,
        getInitialValueInEffect: false,
    });
    const preference = storedVersion === 'new' || storedVersion === 'legacy' ? storedVersion : undefined;
    const view: PageVersion = enabled ? (preference ?? 'new') : 'legacy';

    return {
        view,
        enabled,
        isPending,
        setView,
        switchView: () => setView(view === 'new' ? 'legacy' : 'new'),
    };
};
